import { HANDLE_LOGIN_ERROR, HANDLE_LOGIN_SUCCESS } from "../constants/constants";

const initialState = {
    user: (window.localStorage.getItem("user") !== null && window.localStorage.getItem("user") !== "undefined") ? JSON.parse(window.localStorage.getItem("user")) : null,
    token: (window.localStorage.getItem("token") !== null && window.localStorage.getItem("token") !== "undefined") ? JSON.parse(window.localStorage.getItem("token")) : null,
    message: "",
    fetchsRequest: {}
};

const ConnexionReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case HANDLE_LOGIN_SUCCESS:
            return {
                ...state,
                token: action.payload,
                message: "",
                fetchsRequest: {
                    ...state.fetchsRequest,
                    [action.type.substr(0, action.type.lastIndexOf('_'))]: state.fetchsRequest[action.type.substr(0, action.type.lastIndexOf('_'))] != null ? --state.fetchsRequest[action.type.substr(0, action.type.lastIndexOf('_'))] : 0
                }
            };
        case HANDLE_LOGIN_ERROR:
            return {
                ...state,
                user: null,
                message: action.payload,
                fetchsRequest: {
                    ...state.fetchsRequest,
                    [action.type.substr(0, action.type.lastIndexOf('_'))]: state.fetchsRequest[action.type.substr(0, action.type.lastIndexOf('_'))] != null ? --state.fetchsRequest[action.type.substr(0, action.type.lastIndexOf('_'))] : 0
                }
            };
        case 'FETCH_HANDLE_LOGIN':
            return {
                ...state,
                fetchsRequest: {
                    ...state.fetchsRequest,
                    [action.type.substr(action.type.indexOf('_') + 1)]: state.fetchsRequest[action.type.substr(action.type.indexOf('_') + 1)] != null ? ++state.fetchsRequest[action.type.substr(action.type.indexOf('_') + 1)] : 1
                }
            }
        case 'UPDATE_USER_INFO':
            return {
                ...state,
                user: action.payload,
            };
        default:
            return state;
    }
};

export default ConnexionReducer;
